import { Button, Image, Form, Input } from "antd";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import DataProvider from "../../services";

export default function ClaimDetails(props: any) {
  const navigate = useNavigate();
  const { persist } = props;
  const [form] = Form.useForm();
  const [loading, setLoading] = useState<boolean>(false);

  async function _onProceedD() {
    try {
      setLoading(true);
      const payload = {
        deathCertificate: persist.deathCertificate,
        policeReport: persist.policeReport,
        affidavits: persist.affidavits,
        nationalId: persist.nationalId,
      };
      await DataProvider.createDeathClaim(payload);
      setLoading(false);
      navigate("/main/claims");
    } catch (error) {
      setLoading(false);
    }
  }
  async function _onProceedH() {
    const values = await form.getFieldsValue();
    try {
      setLoading(true);
      const payload = {
        hospitalInvoice: persist.hospitalInvoice,
        dischargeslip: persist.dischargeslip,
        excuseDuty: persist.excuseDuty,
        nationalId: persist.nationalId,
        notes: values.notes ? values.notes : "N/A",
      };
      await DataProvider.createHospitalizedClaim(payload);
      setLoading(false);
      navigate("/main/claims");
    } catch (error) {
      setLoading(false);
    }
  }

  const goBackHandler = () => {
    props.setTab(1); // Back to the Uploads step
  };

  const documents =
    persist.type === "Death"
      ? [
          { label: "Death certificate", src: persist.deathCertificate },
          { label: "Police report", src: persist.policeReport },
          { label: "Affidavits", src: persist.affidavits },
          { label: "National ID", src: persist.nationalId },
        ]
      : [
          { label: "Hospital invoice", src: persist.hospitalInvoice },
          { label: "Discharge slip", src: persist.dischargeslip },
          { label: "Excuse duty", src: persist.excuseDuty },
          { label: "National ID", src: persist.nationalId },
        ];
  const attached = documents.filter((d) => d.src);

  return (
    <div className="w-full flex justify-center px-4">
      <div className="w-full max-w-xl">
        <h2 className="font-semibold text-lg text-center text-neutral-900 mb-1">
          Review &amp; submit
        </h2>
        <p className="text-sm text-neutral-500 text-center mb-6">
          Confirm your documents before submitting your {persist.type}{" "}
          claim.
        </p>

        <div className="rounded-xl border border-neutral-200 bg-white p-4 sm:p-5 mb-4">
          <p className="text-xs font-semibold text-neutral-500 uppercase tracking-wide mb-3">
            {attached.length} document{attached.length !== 1 ? "s" : ""}{" "}
            attached
          </p>
          <Image.PreviewGroup>
            <div className="grid grid-cols-2 sm:grid-cols-4 gap-3">
              {attached.map((doc) => (
                <div key={doc.label} className="flex flex-col items-center">
                  <Image
                    src={doc.src}
                    alt={doc.label}
                    width={72}
                    height={72}
                    className="rounded-lg object-cover border border-neutral-200"
                    style={{ objectFit: "cover" }}
                  />
                  <p className="text-xs text-neutral-600 text-center mt-1.5 leading-snug">
                    {doc.label}
                  </p>
                </div>
              ))}
            </div>
          </Image.PreviewGroup>
        </div>

        <Form form={form} name="basic" layout="vertical" autoComplete="off">
          <Form.Item name="notes" label="Additional information">
            <Input.TextArea
              rows={3}
              placeholder="Anything else we should know? (optional)"
            />
          </Form.Item>
        </Form>

        <div className="mt-6 space-y-3">
          <Button
            onClick={() =>
              persist.type === "Death" ? _onProceedD() : _onProceedH()
            }
            type="primary"
            size="large"
            loading={loading}
            style={{ backgroundColor: "#06509E" }}
            className="w-full"
          >
            {loading ? "Submitting..." : "Submit claim"}
          </Button>

          <Button
            size="large"
            onClick={goBackHandler}
            disabled={loading}
            className="w-full"
          >
            Back
          </Button>
        </div>
      </div>
    </div>
  );
}
